import React from "react";
import "../../../style.css";
import { PageHeader, Tabs } from "antd";
import GeneralLetter from "./GeneralLetter";
import openNotificationWithIcon from "../../../helpers/notification";
import Letterhead from "./Letterhead";
import LetterCodeMaster from "./LetterCodeMaster";

const Letter = (props) => {
  const { state } = props.location;
  if (state && state.message) {
    openNotificationWithIcon(state.type, "Kelola Surat", state.message);
    props.history.replace({ ...props.location.pathname, state: null });
  }

  return (
    <>
      <div
        className="site-layout-background"
        style={{ padding: 10, minHeight: 360 }}
      >
        <PageHeader
          className="site-page-header"
          onBack={() => null}
          backIcon={null}
          title="Master Surat"
          subTitle="daftar surat"
        />
        <Tabs defaultActiveKey={state ? state.tabKey || "1" : "1"} type="card">
          <Tabs.TabPane tab="Surat Administrasi" key="1">
            <GeneralLetter {...props} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Pengaturan Surat" key="2">
            <Letterhead {...props} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Kode Surat" key="3">
            <LetterCodeMaster {...props} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </>
  );
};

export default Letter;
